import {
  VuexModule,
  Module,
  Mutation,
  getModule
} from "vuex-module-decorators";
import store from "@/general/store";
import Cookies from "js-cookie";

// bsBenefitOneIncクッキー内にloginInfo、ssoFlgのキーが含まれているかチェック処理
const isExistSsoFlg = () => {
  try {
    const raw_cookie = Cookies.get(
      process.env.VUE_APP_COOKIE_NAME ?? "bsBenefitOneInc"
    );

    if (typeof raw_cookie !== "string") {
      return false;
    }

    const parsed_cookie = JSON.parse(raw_cookie);

    return typeof parsed_cookie?.loginInfo?.ssoFlg === "boolean";
  } catch {
    return false;
  }
};

// インテリセンスを効かせるために動的モジュールとして登録
// storeに指定することでモジュール初期化時に自動でストアに登録
// preserveStateをtrueにし、既存の値（Storeがクッキーから読み取った値）は初期化時に上書きしないようにする。
@Module({
  dynamic: true,
  store: store,
  name: "loginInfo",
  namespaced: true,
  preserveState: isExistSsoFlg()
})
class LoginInfoModule extends VuexModule {
  ssoFlg = false;

  get isSso() {
    return Boolean(this.ssoFlg);
  }

  @Mutation
  removeAll() {
    this.ssoFlg = false;
  }

  @Mutation
  setSsoFlg(ssoflg: boolean) {
    this.ssoFlg = ssoflg;
  }
}

export default getModule(LoginInfoModule);
